package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

interface ExposureStepStrategy {

    fun apply(
        context: ExposureStepContext,
    ): ProgressiveExposureState
}

class HalfExposureStrategy : ExposureStepStrategy {

    override fun apply(
        context: ExposureStepContext,
    ): ProgressiveExposureState {
        return context.renderer.renderHalfStep(
            state = context.state,
        )
    }
}

class VerseExposureStrategy : ExposureStepStrategy {

    override fun apply(
        context: ExposureStepContext,
    ): ProgressiveExposureState {
        return context.renderer.renderVerseStep(
            state = context.state,
        )
    }
}

class WordExposureStrategy : ExposureStepStrategy {

    override fun apply(
        context: ExposureStepContext,
    ): ProgressiveExposureState {
        return context.renderer.renderWordStep(
            state = context.state,
        )
    }
}
